import React, { createElement } from "react";
import moduleCss from "./index.module.scss";

interface textInfoProps {
    swiperIndex: number
    title?: string
    summary?: string
}

const TextInfo_skin0 = (props: textInfoProps) => {
    const { swiperIndex, title, summary } = props

    const getIndex = () => {
        return String(swiperIndex + 1).length === 1 ? `0${swiperIndex + 1}` : swiperIndex + 1;
    };

    return (
        <div className={moduleCss.text}>
            <div className={moduleCss.index}>
                第<span>{getIndex()}</span>张
            </div>
            <div className={moduleCss.content}>
                <div className={moduleCss.title}>
                    {title}
                </div>
                <div className={moduleCss.subTitle}>
                    {summary}
                </div>
            </div>
        </div>
    )
}

export default TextInfo_skin0
